module.exports = __webpack_public_path__ + "img/xiugaijiage.fad73864.png";